import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import App from './app/App';
import constants from 'constants';
import loadGoogleMapsAPI from 'load-google-maps-api';

let render;

loadGoogleMapsAPI({
    key: constants.GOOGLE_MAP_API_KEY,
    libraries: ['drawing', 'geometry'],
}).then(() => {
    render = (Component) => {
        ReactDOM.render(
            <AppContainer>
                <Component />
            </AppContainer>,
            document.getElementById('root'),
        );
    };

    render(App);
});

if (module.hot) {
    module.hot.accept('./app/App', () => {
        render(App);
    });
}



// WEBPACK FOOTER //
// ./main.js